export default __webpack_public_path__ + "images/9A.94d8141.png";